import { tenantMemberState } from "../interfaces/tenantMember"
import { Types } from "../types"
import { TenantMemberTypesActions } from "../types/tenantMember/actionTypes"


const initialState: tenantMemberState = {

    getTenantWebsiteDomainPending: false,
    getTenantWebsiteDomainSuccess: false,
    getTenantWebsiteDomainError: null,
    domains: null,

    addNewTenantMemberPending: false,
    addNewTenantMemberSuccess: false,
    addNewTenantMemberError: null,

    getTenantMemberForUpdatePending: false,
    getTenantMemberForUpdateSuccess: false,
    getTenantMemberForUpdateError: null,
    resultGetForUpdate: null,

    deleteTenantMemberPending: false,
    deleteTenantMemberSuccess: false,
    deleteTenantMemberError: null,

    updateTenantMemberPending: false,
    updateTenantMemberSuccess: false,
    updateTenantMemberError: null,
    resultUpdate: null,

    getTenantMemberSoftPhoneDetailPending: false,
    getTenantMemberSoftPhoneDetailSuccess: false,
    getTenantMemberSoftPhoneDetailError: null,
    softPhoneDetails: null,

    sendSoftPhoneDetailToTenantMemberPending: false,
    sendSoftPhoneDetailToTenantMemberSuccess: false,
    sendSoftPhoneDetailToTenantMemberError: null,

    toggleTenantMemberStatusPending: false,
    toggleTenantMemberStatusSuccess: false,
    toggleTenantMemberStatusError: null,

    getAvailableInternalPhonePending: false,
    getAvailableInternalPhoneSuccess: false,
    getAvailableInternalPhoneError: null,
    result: ''
}



const tenantMemberReducer = (state = initialState, action: TenantMemberTypesActions) => {

    switch (action.type) {
        case Types.ADD_NEW_TENANT_MEMBER_REQUEST:
            return {
                ...state,
                addNewTenantMemberPending: true,
                addNewTenantMemberSuccess: false,
                addNewTenantMemberError: null

            }
        case Types.ADD_NEW_TENANT_MEMBER_SUCCESS:

            return {
                ...state,
                addNewTenantMemberPending: false,
                addNewTenantMemberSuccess: true,
                addNewTenantMemberError: null

            }

        case Types.ADD_NEW_TENANT_MEMBER_ERROR:

            return {
                ...state,
                addNewTenantMemberPending: false,
                addNewTenantMemberSuccess: false,
                addNewTenantMemberError: action?.payload
            }

        //************ ***********************************************************************/

        case Types.GET_AVAILABLE_INTERNAL_PHONE_REQUEST:
            return {
                ...state,
                getAvailableInternalPhonePending: true,
                getAvailableInternalPhoneSuccess: false,
                getAvailableInternalPhoneError: null,


            }
        case Types.GET_AVAILABLE_INTERNAL_PHONE_SUCCESS:
            return {
                ...state,
                getAvailableInternalPhonePending: false,
                getAvailableInternalPhoneSuccess: true,
                getAvailableInternalPhoneError: null,
                result: action?.payload?.params

            }

        case Types.GET_AVAILABLE_INTERNAL_PHONE_ERROR:

            return {
                ...state,
                getAvailableInternalPhonePending: false,
                getAvailableInternalPhoneSuccess: false,
                getAvailableInternalPhoneError: action?.payload
            }
        //*********************************************************************************** */
        case Types.UPDATE_TENANT_MEMBER_REQUEST:
            return {
                ...state,
                updateTenantMemberPending: true,
                updateTenantMemberSuccess: false,
                updateTenantMemberError: null,
                resultUpdate: '',


            }
        case Types.UPDATE_TENANT_MEMBER_SUCCESS:
            return {
                ...state,
                updateTenantMemberPending: false,
                updateTenantMemberSuccess: true,
                updateTenantMemberError: null,
                resultUpdate: action?.payload,

            }

        case Types.UPDATE_TENANT_MEMBER_ERROR:

            return {
                ...state,
                updateTenantMemberPending: false,
                updateTenantMemberSuccess: false,
                updateTenantMemberError: action.payload,
                resultUpdate: '',
            }
        //************************************************************************************** */
        case Types.DELETE_TENANT_MEMBER_REQUEST:
            return {
                ...state,
                deleteTenantMemberPending: true,
                deleteTenantMemberSuccess: false,
                deleteTenantMemberError: null,


            }
        case Types.DELETE_TENANT_MEMBER_SUCCESS:
            return {
                ...state,
                deleteTenantMemberPending: false,
                deleteTenantMemberSuccess: true,
                deleteTenantMemberError: null,

            }

        case Types.DELETE_TENANT_MEMBER_ERROR:

            return {
                ...state,
                deleteTenantMemberPending: false,
                deleteTenantMemberSuccess: false,
                deleteTenantMemberError: action?.payload,
            }
        //********************************************************************************** */
        case Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_REQUEST:
            return {
                ...state,
                getTenantMemberForUpdatePending: true,
                getTenantMemberForUpdateSuccess: false,
                getTenantMemberForUpdateError: null,
                resultGetForUpdate: null,


            }
        case Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_SUCCESS:
            return {
                ...state,
                getTenantMemberForUpdatePending: false,
                getTenantMemberForUpdateSuccess: true,
                getTenantMemberForUpdateError: null,
                resultGetForUpdate: action?.payload,

            }

        case Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_ERROR:

            return {
                ...state,
                getTenantMemberForUpdatePending: false,
                getTenantMemberForUpdateSuccess: false,
                getTenantMemberForUpdateError: action?.payload,
                resultGetForUpdate: null,
            }

        //*************************************************************** */
        case Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_REQUEST:
            return {
                ...state,
                getTenantMemberSoftPhoneDetailPending: true,
                getTenantMemberSoftPhoneDetailSuccess: false,
                getTenantMemberSoftPhoneDetailError: null,
            }
        case Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_SUCCESS:
            return {
                ...state,
                getTenantMemberSoftPhoneDetailPending: false,
                getTenantMemberSoftPhoneDetailSuccess: true,
                getTenantMemberSoftPhoneDetailError: null,
                softPhoneDetails: action?.payload
            }

        case Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_ERROR:

            return {
                ...state,
                getTenantMemberSoftPhoneDetailPending: false,
                getTenantMemberSoftPhoneDetailSuccess: false,
                getTenantMemberSoftPhoneDetailError: action?.payload,
            }
        //******************************************************************** */
        case Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_REQUEST:
            return {
                ...state,
                sendSoftPhoneDetailToTenantMemberPending: true,
                sendSoftPhoneDetailToTenantMemberSuccess: false,
                sendSoftPhoneDetailToTenantMemberError: null,
            }
        case Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_SUCCESS:
            return {
                ...state,
                sendSoftPhoneDetailToTenantMemberPending: false,
                sendSoftPhoneDetailToTenantMemberSuccess: true,
                sendSoftPhoneDetailToTenantMemberError: null,

            }
        case Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_ERROR:

            return {
                ...state,
                sendSoftPhoneDetailToTenantMemberPending: false,
                sendSoftPhoneDetailToTenantMemberSuccess: false,
                sendSoftPhoneDetailToTenantMemberError: action?.payload,
            }
        //****************************************************************** */
        case Types.TOGGLE_TENANT_MEMBER_STATUS_REQUEST:
            return {
                ...state,
                toggleTenantMemberStatusPending: true,
                toggleTenantMemberStatusSuccess: false,
                toggleTenantMemberStatusError: null,
            }
        case Types.TOGGLE_TENANT_MEMBER_STATUS_SUCCESS:
            return {
                ...state,
                toggleTenantMemberStatusPending: false,
                toggleTenantMemberStatusSuccess: true,
                toggleTenantMemberStatusError: null,
            }
        case Types.TOGGLE_TENANT_MEMBER_STATUS_ERROR:

            return {
                ...state,
                toggleTenantMemberStatusPending: false,
                toggleTenantMemberStatusSuccess: false,
                toggleTenantMemberStatusError: action?.payload,
            }
        //************************************ */

        case Types.GET_TENANT_WEBSITE_DOMAIN_REQUEST:
            return {
                ...state,
                getTenantWebsiteDomainPending: true,
                getTenantWebsiteDomainSuccess: false,
                getTenantWebsiteDomainError: null,
                domains: null,
            }
        case Types.GET_TENANT_WEBSITE_DOMAIN_SUCCESS:
            return {
                ...state,
                getTenantWebsiteDomainPending: false,
                getTenantWebsiteDomainSuccess: true,
                getTenantWebsiteDomainError: null,
                domains: action?.payload,
            }
        case Types.GET_TENANT_WEBSITE_DOMAIN_ERROR:

            return {
                ...state,
                getTenantWebsiteDomainPending: false,
                getTenantWebsiteDomainSuccess: false,
                getTenantWebsiteDomainError: action?.payload,
                domains: null,
            }
        //****************************************** */
        case Types.RESET_DELETE_TENANT:

            return {
                ...state,
                deleteTenantMemberPending: false,
                deleteTenantMemberSuccess: false,
                deleteTenantMemberError: null,
                toggleTenantMemberStatusPending: false,
                toggleTenantMemberStatusSuccess: false,
                toggleTenantMemberStatusError: null,
            }
        default:
            return {
                ...state
            }
    }
}

export default tenantMemberReducer